import React, { Component } from 'react';
import Chart from 'chart.js';
import Skeleton from 'react-loading-skeleton';
import { commaingNumber } from '../../../utils';

class GroupedBarGraph extends Component {
  constructor(props) {
    super(props);
    this.state = {
      myChart: null,
    };
  }
  drawGraph = () => {
    var ctx = document.getElementById(this.props.id).getContext('2d');
    /**setting width of bar graph*/
    ctx.canvas.parentNode.style.width = this.props.width;

    const getBarTag = (type, value) => {
      if (!type) return '';
      else if (type === 'value') return value;
      else if (type === 'percentage') return value + '%';
    };


    if (this.state.myChart) {
      this.state.myChart.destroy();
    }

    this.state.myChart = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: this.props.label,
        datasets: this.props.graphData
    },

      options: {
        maintainAspectRatio: false /**to set custom height and width of bar graph set maintainAspectRatio to false*/,
        barTag: 'percentage',
        legend: {
          display: true,
          position: 'top',
          align:'end',
          labels: {
            boxWidth: 16,
            boxHeight:16,
            color:'#324467',
            font: {
                size: 14,
                family: 'proxima nova',
                weight:'400'
            }
        }
    
        },
        tooltips: {
          enabled: false,
        },
        scales: {
          xAxes: [
            {
              maxBarThickness: 60,
              barThickness: 30,
              scaleLabel: {
                display: true,
                labelString: this.props.xAxesLabel,
                fontStyle: 'bold',
                fontSize: 14,
                fontColor: '#4d6189',
                fontFamily: 'ProximaNova',
              },
              gridLines: {
                display: false,
              },
              ticks:
                {min: 0, max: 120, },
            },
          ],
          yAxes: [
            {
              maxBarThickness: 60,
              barThickness: 30,
              scaleLabel: {
                display: true,
                labelString: this.props.yAxesLabel,
                fontStyle: 'bold',
                fontSize: 14,
                fontColor: '#4d6189',
              },
              gridLines: {
                drawBorder: false,
                display: true,
              },
              ticks:
              {min: 0, max: 100, stepSize: 20,},
              stacked: false,
            },
          ],
        },
        animation: {
            duration: 1,
            onComplete: function () {
              var chartInstance = this.chart;
              ctx = chartInstance.ctx;
              ctx.textAlign = 'center';
              ctx.font = Chart.helpers.fontString(12, 'bold', Chart.defaults.global.defaultFontFamily);
              ctx.fillStyle = '#4D6189';
              ctx.textBaseline = 'bottom';
  
              this.data.datasets.forEach((dataset, i) => {
                var meta = chartInstance.controller.getDatasetMeta(i);
                meta.data.forEach((bar, index) => {
                  var data = getBarTag(this.config.options.barTag, dataset.data[index]);
                  ctx.fillText(data, bar._model.x, bar._model.y - 5);
                });
              });
            },
          },
        hover: {
          animationDuration: 0,
        },
      },
    });
  };

  componentDidMount() {
    this.drawGraph();
  }

  componentDidUpdate() {
     this.drawGraph();
  }

  render() {
    if (this.props.loading) {
      return <Skeleton width='100%' height={300} />;
    }

    return (
      /**set height of bar graph by inline styling canvas */
      <div className={`p-4 h-full ` +  'pt-6'}>
        <canvas id={this.props.id} style={{ height: 300 }}></canvas>
      </div>
    );
  }
}

export default GroupedBarGraph;
